import styled from 'styled-components'

import { StatusBar, PlayerBoard } from '.'

export const Column = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: stretch;
`

function StageScreen() {
    return (
        <Column>
            <StatusBar />
            <PlayerBoard />
        </Column>
    )
}

export default StageScreen